import { z } from 'zod';
export const registry = z.registry();
